import styled, { css } from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import { Gender as GenderType, getGenderLabel } from 'src/utils/profileUtil';
import i18n from 'src/utils/translate';
import { textSmallLight } from 'styles-js/mixins/typography';
type Props = {
  gender?: GenderType;
  age?: number;
  country?: string;
};
export default function MemberCardInfo({
  gender,
  age,
  country
}: Props) {
  const ageRef = useRef<HTMLSpanElement>(null);
  const [isAgeOverflowing, setIsAgeOverflowing] = useState(false);
  useEffect(() => {
    if (!ageRef.current) return;
    setIsAgeOverflowing(ageRef.current?.offsetWidth < ageRef.current?.scrollWidth);
  }, []);
  return <Info data-sentry-element="Info" data-sentry-component="MemberCardInfo" data-sentry-source-file="memberCardInfo.tsx">
      {gender && gender !== GenderType.none && <Gender title={getGenderLabel(gender)}>{getGenderLabel(gender)}</Gender>}

      {age && <span ref={ageRef}>{age}<YearsOld $isHidden={isAgeOverflowing}>{' '}{i18n.t('years old')}</YearsOld></span>}

      {country && <Country title={country}>{country}</Country>}
    </Info>;
}
const Info = styled.div`
  ${textSmallLight}
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  white-space: nowrap;
  span:not(:first-child)::before {
    content: "•";
    color: ${({
  theme
}) => theme.colorGreyLight};
    margin: 0 4px;
  }
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 4ch;
  }
`;
const Gender = styled.span`
  max-width: 17ch;
`;
const YearsOld = styled.span<{
  $isHidden: boolean;
}>`
  ${({
  $isHidden
}) => $isHidden && css`
    display: none;
  `}
`;
const Country = styled.span`
  max-width: 28ch;
`;